// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__o5ogi","label":"styles_label__3J8Yd"};